import { useState } from "react";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";
import PageHeader from "../../components/PageHeader";
import FeesList from "./FeesList";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import { useNavigate } from "react-router-dom";
import AcademicCycleSelect from "../../components/common-input/AcademicCycle";
import ClassSelect from "../../components/common-input/ClassSelect";

export default function FeesAndPayment() {
  const [activeTab, setActiveTab] = useState("All Invoices");
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col gap-6">
      <div
        className="
        flex flex-col gap-4 
        lg:flex-row lg:items-center lg:justify-between
      "
      >
        <PageHeader />

        <div
          className="
            flex flex-wrap md:flex-nowrap gap-3 
            w-full lg:w-auto 
          "
        >
          {(activeTab === "All Invoices" ||
            activeTab === "Recurring Invoice") && (
            <>
              <ClassSelect
                name="classFilter"
                placeholder="Filter by class..."
                value=""
                onChange={() => {}}
                selectClassName="bg-white border-none w-full sm:w-auto"
              />
              <AcademicCycleSelect
                name="cycleFilter"
                placeholder="Filter by academic cycle..."
                value=""
                onChange={() => {}}
                selectClassName="bg-white border-none w-full sm:w-auto"
              />
              <CustomInput
                name="dateFilter"
                type="date"
                value=""
                onChange={() => {}}
                inputClassName="bg-white border-none w-full sm:w-auto"
              />
            </>
          )}

          {activeTab === "Templates" && (
            <CustomButton
              color="bg-success-500"
              text="New Template"
              onClick={() => navigate(popupNavigation("createTemplate"))}
            />
          )}

          <CustomButton
            color="bg-primary-500"
            text="New Invoice"
            onClick={() => navigate(popupNavigation("newInvoice"))}
          />
        </div>
      </div>
      <FeesList activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
}
